/** Statuses that indicate the file is still needs to be processed. */
export const FILE_PROCESSING_STATUSES_PENDING = [
  'pending',
  'processing',
  'retrying',
  'verifying',
] as const
/** */
export const FILE_PROCESSING_STATUSES_TERMINAL = [
  'processed',
  'failed',
] as const
/**
 * Backend `FileProcessingStatus` — single source of truth for API + websocket payloads.
 */
export const FILE_PROCESSING_STATUSES = [
  ...FILE_PROCESSING_STATUSES_PENDING,
  ...FILE_PROCESSING_STATUSES_TERMINAL,
] as const

export type IFileProcessingStatusPending =
  (typeof FILE_PROCESSING_STATUSES_PENDING)[number]
export type IFileProcessingStatusTerminal =
  (typeof FILE_PROCESSING_STATUSES_TERMINAL)[number]
export type IFileProcessingStatus = (typeof FILE_PROCESSING_STATUSES)[number]

/** Non-terminal states (file must not be shown as done or failed yet). */
export const UPLOADED_FILE_IN_PROGRESS_STATUSES = [
  'pending',
  'processing',
  'retrying',
  'verifying',
] as const satisfies readonly IFileProcessingStatus[]
